
export type ItemType = 'ball' | 'shoot' | 'sub' | 'yellow' | 'red' | 'offside' | 'tackle';

export interface Orb {
  id: string;
  x: number;
  y: number;
  radius: number;
  color: string;
  createdAt: number;
  lifeSpan: number;
  type: ItemType;
}

export interface Particle {
  id: string;
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  color: string;
  size: number;
}

export enum GameStatus {
  START = 'START',
  PLAYING = 'PLAYING',
  GAMEOVER = 'GAMEOVER'
}
